import React from "react";
import LoadingSpinner from "@/app/components/LoadingSpinner";

const Loading = () => {
    return (
        <div className="flex items-center justify-center min-h-screen text-white">
            <LoadingSpinner/>
        </div>
    );
}

export default Loading;